import React from 'react';
import { motion } from 'framer-motion';
import { Users, Plus, MoreHorizontal, Mail, Shield } from 'lucide-react';
export function TeamPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-6xl mx-auto" data-id="element-4791">
      {/* Header */}
      <div className="flex justify-between items-center mb-6" data-id="element-4792">
        <h2 className="text-2xl font-bold" data-id="element-4793">Team Members</h2>
        <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2 text-sm shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-4794">
          <Plus className="w-4 h-4" data-id="element-4795" />
          Invite Member
        </button>
      </div>

      {/* Workload Widgets */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-4796">
        <div className="bg-surface border border-border rounded-xl p-5" data-id="element-4797">
          <div className="text-sm text-textMuted mb-1" data-id="element-4798">
            Active Deals (Total)
          </div>
          <div className="text-2xl font-bold" data-id="element-4799">24</div>
        </div>
        <div className="bg-surface border border-border rounded-xl p-5" data-id="element-4800">
          <div className="text-sm text-textMuted mb-1" data-id="element-4801">Pending Approvals</div>
          <div className="text-2xl font-bold text-amber-500" data-id="element-4802">5</div>
        </div>
        <div className="bg-surface border border-border rounded-xl p-5" data-id="element-4803">
          <div className="text-sm text-textMuted mb-1" data-id="element-4804">
            Unassigned Inquiries
          </div>
          <div className="text-2xl font-bold text-primary" data-id="element-4805">3</div>
        </div>
      </div>

      {/* Team Table */}
      <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-4806">
        <table className="w-full text-sm text-left" data-id="element-4807">
          <thead className="bg-background border-b border-border text-textMuted" data-id="element-4808">
            <tr data-id="element-4809">
              <th className="px-6 py-4 font-medium" data-id="element-4810">Member</th>
              <th className="px-6 py-4 font-medium" data-id="element-4811">Role</th>
              <th className="px-6 py-4 font-medium" data-id="element-4812">Assigned Deals</th>
              <th className="px-6 py-4 font-medium" data-id="element-4813">Last Active</th>
              <th className="px-6 py-4 text-right" data-id="element-4814">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border" data-id="element-4815">
            {[{
            name: 'Mark Thompson',
            email: 'mark@thewildwoodsband.com',
            role: 'Admin',
            deals: 12,
            active: 'Just now',
            initials: 'MT',
            color: 'primary'
          }, {
            name: 'Sarah Chen',
            email: 'sarah@thewildwoodsband.com',
            role: 'Member',
            deals: 8,
            active: '2 hours ago',
            initials: 'SC',
            color: 'blue'
          }, {
            name: 'Alex Rivera',
            email: 'alex@bookingagency.com',
            role: 'Agent',
            deals: 4,
            active: '1 day ago',
            initials: 'AR',
            color: 'purple'
          }].map((member, i) => <tr key={i} className="hover:bg-surfaceHover transition-colors" data-id="element-4816">
                <td className="px-6 py-4 font-medium flex items-center gap-3" data-id="element-4817">
                  <div className={`w-8 h-8 rounded-full bg-${member.color}-500/20 border border-${member.color}-500/30 flex items-center justify-center text-xs font-bold text-${member.color}-500`} data-id="element-4818">
                    {member.initials}
                  </div>
                  <div data-id="element-4819">
                    <div data-id="element-4820">{member.name}</div>
                    <div className="text-xs text-textMuted font-normal" data-id="element-4821">
                      {member.email}
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-4822">
                  <span className="flex items-center gap-1.5 text-textMuted" data-id="element-4823">
                    {member.role === 'Admin' && <Shield className="w-3.5 h-3.5" data-id="element-4824" />}
                    {member.role}
                  </span>
                </td>
                <td className="px-6 py-4 font-medium" data-id="element-4825">{member.deals}</td>
                <td className="px-6 py-4 text-textMuted" data-id="element-4826">{member.active}</td>
                <td className="px-6 py-4 text-right" data-id="element-4827">
                  <button className="p-1 text-textMuted hover:text-textMain transition-colors rounded hover:bg-background" data-id="element-4828">
                    <MoreHorizontal className="w-4 h-4" data-id="element-4829" />
                  </button>
                </td>
              </tr>)}
            <tr className="bg-background/50" data-id="element-4830">
              <td className="px-6 py-4 font-medium flex items-center gap-3" data-id="element-4831">
                <div className="w-8 h-8 rounded-full bg-surface border border-border border-dashed flex items-center justify-center text-xs text-textMuted" data-id="element-4832">
                  <Mail className="w-3.5 h-3.5" data-id="element-4833" />
                </div>
                <div data-id="element-4834">
                  <div className="text-textMuted italic" data-id="element-4835">Pending Invite</div>
                  <div className="text-xs text-textMuted font-normal" data-id="element-4836">
                    tourmgr@thewildwoodsband.com
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 text-textMuted" data-id="element-4837">Member</td>
              <td className="px-6 py-4 text-textMuted" data-id="element-4838">-</td>
              <td className="px-6 py-4 text-textMuted" data-id="element-4839">-</td>
              <td className="px-6 py-4 text-right" data-id="element-4840">
                <button className="text-xs text-primary hover:underline font-medium" data-id="element-4841">
                  Resend
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </motion.div>;
}